import { Component, signal, Signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';
import { environment } from '../../../../environments/environment';

const API_KEY = 'AIzaSyDkwoPWUrcqct0d7jpG_vTinKl53ixorwc';

@Component({
  selector: 'app-c-google-maps',
  imports: [],
  templateUrl: './c-google-maps.component.html',
  styleUrl: './c-google-maps.component.scss'
})
export class CGoogleMapsComponent {
  
  #cid: string | null;
  #url: string | null;
  public mapUrl: SafeResourceUrl;
  public isAdminPage = environment.isAdminPage;

  constructor(
    private websiteState: WebsiteStateService,
    private sanitizer: DomSanitizer
  ) {
    this.#cid = this.websiteState.configuration().shopId;
    this.#url = `https://www.google.com/maps/embed/v1/place?q=place_id:${this.#cid}&key=${API_KEY}`;
    this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.#url);
  }

  // TODO: _isCookiePolicyAccepted$ is currently not initialized in admin mode. Fix this properly.
  public ccAccepted$: Signal<boolean> = this.isAdminPage ? signal<boolean>(true) : this.websiteState.ccAccepted;

}
